"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureTier = void 0;
var FeatureTier;
(function (FeatureTier) {
    FeatureTier["Free"] = "free";
    FeatureTier["Paid"] = "paid";
})(FeatureTier = exports.FeatureTier || (exports.FeatureTier = {}));
